( ( $ ) => {
    "use strict";

    const $nav = $( '.section-gaming-guide-ages .gaming-guide-ages__nav' );
    const $slider = $( '.section-gaming-guide-ages .gaming-guide-ages__slides' );

    function initSlider( $sliderEl ) {
        $sliderEl.slick( {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            mobileFirst: true,
            arrows: false,
            dots: false,
            fade: true,
            responsive: [
                {
                    breakpoint: 1199,
                    settings: {
                        dots: false
                    }
                },
            ]
        } ).on( 'beforeChange', function ( event, slick, currentSlide, nextSlide ) {
            console.log( currentSlide );
            setActive( $slider, $nav, nextSlide );
        } );
    }

    function initNav( $navEl, $sliderEl ) {
        if ( window.innerWidth <= 1200 && ( !$navEl.hasClass( 'slick-initialized' ) ) ) {
            $navEl.slick( {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: false,
                mobileFirst: true,
                arrows: true,
                dots: false,
                asNavFor: $sliderEl,
                // centerMode: true,
                focusOnSelect: true,
                responsive: [
                    {
                        breakpoint: 1199,
                        settings: 'unslick'
                    },
                ]
            } );
        }
    }

    function setActive( $sliderEl, $navEl, slideIndex ) {
        const $btn = $navEl.find( '.gaming-guide-ages__nav-item' ).eq( slideIndex );
        const $slide = $sliderEl.find( '.gaming-guide-ages__slide' ).eq( slideIndex );
        $navEl.find( '.gaming-guide-ages__nav-item' ).not( $btn ).removeClass( 'active' );
        $btn.addClass( 'active' );
        if ( $navEl.hasClass( 'slick-initialized' ) ) {
            $navEl.slick( 'slickGoTo', slideIndex );
        }
        $sliderEl.find( '.gaming-guide-ages__slide' ).not( $slide ).removeClass( 'active' );
        $slide.addClass( 'active' );
    }

    $nav.on( 'click', 'a', function ( event ) {
        event.preventDefault();
        const $btn = $( this );
        const slideIndex = $btn.index();
        $slider.slick( 'slickGoTo', slideIndex );
        // setActive( $slider, $nav, slideIndex );
    } );

    $( window ).on( 'load resize', function () {
        initNav( $nav, $slider );
    } );

    initSlider( $slider );

} )( jQuery );